import PropTypes from 'prop-types';
import {I18n, Translate} from 'react-redux-i18n';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';

import {COUNTRY} from 'front-onceforall-core/dist/utils/country';

import {BUSINESS_LINES_BY_COUNTRY} from '../../utils/constant';

/**
 * Selector of a business line.
 *
 * Usage:
 * <BusinessLineSelector
 *   country="..." // Country code (e.g. 'FRANCE')
 *   value="..."   // Business line internal code (e.g. 'CONSTRUCTION')
 *   disabled="..."
 *   onChange="..."
 *   />
 */
function BusinessLineSelector(props) {
  // Builds menu items depending on the input country.
  // An array of HTML menu items to be injected in the DOM, ordered alphabetically by business line labels
  function buildMenuItems() {
    const businessLinesByCountry = BUSINESS_LINES_BY_COUNTRY[props.country] || BUSINESS_LINES_BY_COUNTRY[COUNTRY.FRANCE];
    return businessLinesByCountry
      .map(businessLine => ({
        label: I18n.t(`organisation.businessLine.${businessLine}`),
        value: businessLine
      }))
      .sort((item1, item2) => item1.label.localeCompare(item2.label))
      .map((businessLineItem, index) => (
        <MenuItem
          value={businessLineItem.value}
          key={index}
        >
          <Translate value={businessLineItem.label}/>
        </MenuItem>
      ));
  }

  return (
    <TextField
      name="businessLine"
      id="businessLine"
      select
      disabled={props.disabled}
      value={props.value}
      onChange={props.onChange}
      label={<span><Translate value="organisation.businessLine.title"/> *</span>}
    >
      {buildMenuItems()}
    </TextField>
  );
}

BusinessLineSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  country: PropTypes.string.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool
};

export default BusinessLineSelector;
